/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IPreOpAnaesthesiaChart } from 'app/shared/model/pre-op-anaesthesia-chart.model';
import { OPVentilation } from 'app/shared/model/enumerations/op-ventilation.model';

export interface IIntraOPChart {
  id?: string;
  oxygen?: string | null;
  nitrousOxide?: string | null;
  halothane?: string | null;
  isoflurane?: string | null;
  sevoflurane?: string | null;
  desflurane?: string | null;
  invasiveLines?: string | null;
  urineOutput?: string | null;
  bloodLoss?: string | null;
  otherLosses?: string | null;
  opVentilation?: keyof typeof OPVentilation | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  patient?: IGlucoUser;
  anaesthesiologist?: IDoctor;
  surgeon?: IDoctor;
  nurse?: INurse | null;
  vitals?: IVitals | null;
  preOpAnaesthesiaChart?: IPreOpAnaesthesiaChart;
}

export const defaultValue: Readonly<IIntraOPChart> = {
  active: false,
};
